import React from "react";
import "./FacesheetThirdPartyLiability.scss";

export const FacesheetThirdPartyLiability = ({ thirdPartyLiability }) => {
    return (
        <div className="facesheet_tpl">
            <div className="tpl-item">
                <span className="h5">Type of Accident</span>
                <span className="p-regular">{thirdPartyLiability.typeOfAccident}</span>
            </div>
            {thirdPartyLiability.typeOfAccident === "Automobile" && (
                <>
                    <div className="tpl-item">
                        <span className="h5">Company Name</span>
                        <span className="p-regular">{thirdPartyLiability.companyName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Policy Number</span>
                        <span className="p-regular">{thirdPartyLiability.policyNumber || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Name</span>
                        <span className="p-regular">{thirdPartyLiability.contactName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Phone Number</span>
                        <span className="p-regular">{thirdPartyLiability.contactPhoneNumber || "N/A"}</span>
                    </div>
                </>
            )}
            {thirdPartyLiability.typeOfAccident === "Work-Related" && (
                <>
                    <div className="tpl-item">
                        <span className="h5">Employer Name</span>
                        <span className="p-regular">{thirdPartyLiability.employerName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Name</span>
                        <span className="p-regular">{thirdPartyLiability.contactName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Phone Number</span>
                        <span className="p-regular">{thirdPartyLiability.contactPhoneNumber || "N/A"}</span>
                    </div>
                </>
            )}
            {thirdPartyLiability.typeOfAccident === "At someone's home" && (
                <>
                    <div className="tpl-item">
                        <span className="h5">Homeowner's Company</span>
                        <span className="p-regular">{thirdPartyLiability.homeownerCompany || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Name</span>
                        <span className="p-regular">{thirdPartyLiability.contactName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Policy Number</span>
                        <span className="p-regular">{thirdPartyLiability.policyNumber || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Phone Number</span>
                        <span className="p-regular">{thirdPartyLiability.phoneNumber || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Med Pay Coverage</span>
                        <span className="p-regular">{thirdPartyLiability.medPayCoverage || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Liability Limits</span>
                        <span className="p-regular">{thirdPartyLiability.liabilityLimits || "N/A"}</span>
                    </div>
                </>
            )}
            {thirdPartyLiability.typeOfAccident === "At a place of business" && (
                <>
                    <div className="tpl-item">
                        <span className="h5">Business Name</span>
                        <span className="p-regular">{thirdPartyLiability.businessName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Name</span>
                        <span className="p-regular">{thirdPartyLiability.contactName || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Policy Number</span>
                        <span className="p-regular">{thirdPartyLiability.policyNumber || "N/A"}</span>
                    </div>
                    <div className="tpl-item">
                        <span className="h5">Contact Phone Number</span>
                        <span className="p-regular">{thirdPartyLiability.contactPhoneNumber || "N/A"}</span>
                    </div>
                </>
            )}
            {thirdPartyLiability.typeOfAccident === "Victim of violent crime" && (
                <>
                    <div className="tpl-item">
                        <span className="h5">Have Charges Been Filed</span>
                        <span className="p-regular">
                            {thirdPartyLiability.hasChargesBeenFiledForViolentCrime === true ? "Yes" : "No"}
                        </span>
                    </div>
                </>
            )}
            <div className="tpl-item full_row">
                <span className="h5">Additional Notes</span>
                <span className="p-regular">{thirdPartyLiability.additionalNotes}</span>
            </div>
        </div>
    );
};
